import {useSearchParams} from "react-router";
import {FieldDateSwitch2, FieldDateSwitchValue} from "../../ui";
import {FieldMultiSelect} from "@kroschke/react-ui";
import {convertDocumentType, convertScanStatus} from "../../../api";
import {DocumentTypeDto, ScanStatusDto} from "../../../api/sea";
import {useEffect, useState} from "react";
import {pageQueryStore} from "../../../store";
import {updateUrlOnDateSwitchChange, updateUrlParams} from "../../../utils";


const documentDropDownOptions = Object.keys(DocumentTypeDto).map(e => ({
    value: e,
    label: convertDocumentType(e as DocumentTypeDto)
}))

const statusDropDownOptions = Object.keys(ScanStatusDto)
    .filter(e => e !== ScanStatusDto.REVOKED)
    .map(e => ({
        value: e,
        label: convertScanStatus(e as ScanStatusDto)
    }))

function Filterbar() {
    const [searchParams, setSearchParams] = useSearchParams()

    const type = (searchParams.getAll('type') || [])
    const status = (searchParams.getAll('status') || [])

    const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
    const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined
    const queryS = searchParams.get('q') || undefined

    const [from, setFrom] = useState<FieldDateSwitchValue | undefined>(fromS ? {
        absolute: searchParams.get('fromAbsolute') || undefined,
        relative: searchParams.get('fromRelative') || undefined,
    } : undefined)
    const [to, setTo] = useState<FieldDateSwitchValue | undefined>(toS ? {
        absolute: searchParams.get('toAbsolute') || undefined,
        relative: searchParams.get('toRelative') || undefined,
    } : undefined)
    const [docType, setDocType] = useState(type)
    const [docStatus, setDocStatus] = useState(status)

    useEffect(() => {
        const type = (searchParams.getAll('type') || [])
        const status = (searchParams.getAll('status') || [])

        const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
        const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined

        setFrom(fromS ? {
            absolute: searchParams.get('fromAbsolute') || undefined,
            relative: searchParams.get('fromRelative') || undefined,
        } : undefined)
        setTo(toS ? {
            absolute: searchParams.get('toAbsolute') || undefined,
            relative: searchParams.get('toRelative') || undefined,
        } : undefined)
        setDocType(type)
        setDocStatus(status)
    }, [
        searchParams,
        setFrom,
        setTo,
        setDocType,
        setDocStatus
    ])

    const hasFilter = Boolean(fromS) || Boolean(toS) || Boolean(docStatus.length) || Boolean(docType.length) || Boolean(queryS)

    return <div style={{
        display: 'flex',
        zoom: '85%',
        alignItems: 'flex-start',
        zIndex: 1
    }}>

        <div style={{
            minWidth: '10em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Von"}
                value={from}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'from', searchParams, setSearchParams)
                    setFrom(v)
                }}
            />
        </div>
        <div style={{
            minWidth: '10em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Bis"}
                value={to}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'to', searchParams, setSearchParams)
                    setTo(v)
                }}
            />
        </div>
        <div style={{
            minWidth: '10em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldMultiSelect
                label={"Dokumente"}
                options={documentDropDownOptions}
                required={true}
                value={docType}
                onChange={value => {
                    updateUrlParams({val: [{param: 'type', value}], setSearchParams, searchParams})
                    setDocType(value)
                }}
            />
        </div>
        <div style={{
            minWidth: '15em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldMultiSelect
                label={"Status"}
                options={statusDropDownOptions}
                required={true}
                value={docStatus}
                onChange={value => {
                    updateUrlParams({val: [{param: 'status', value}], setSearchParams, searchParams})
                    setDocStatus(value)
                }}
            />
        </div>
        {<div style={{
            minWidth: '10em',
            maxWidth: '20em',
        }}>
            <button
                className={'button is-primary is-rounded'}
                disabled={!hasFilter}
                onClick={() => {
                    setFrom(undefined)
                    setTo(undefined)
                    setDocStatus([])
                    setDocType([])
                    searchParams.delete('status')
                    searchParams.delete('type')
                    searchParams.delete('fromRelative')
                    searchParams.delete('fromAbsolute')
                    searchParams.delete('toRelative')
                    searchParams.delete('toAbsolute')
                    searchParams.delete('q')
                    setSearchParams(searchParams)
                    pageQueryStore.clear('sea')
                }}
                style={{
                    marginTop: '0.3em'
                }}
            >
                <span className={`icon is-small`}>
                    <span className="material-symbols-outlined">filter_list_off</span>
                </span>
                <span>Zurücksetzen</span>
            </button>
        </div>}
    </div>
}

export {
    Filterbar
}
